import alertIcon from '@/assets/icons/alertIcon.svg';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';

interface DeleteConfirmationDialogProps {
  cancelLabel?: string;
  confirmLabel?: string;
  description: string;
  isPending?: boolean;
  onConfirm: () => void | Promise<void>;
  onOpenChange: (open: boolean) => void;
  open: boolean;
  title: string;
}

export function DeleteConfirmationDialog({
  cancelLabel = 'Cancel',
  confirmLabel = 'Delete',
  description,
  isPending = false,
  onConfirm,
  onOpenChange,
  open,
  title,
}: DeleteConfirmationDialogProps) {
  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent showCloseButton={false}>
        <DialogHeader className="flex flex-col items-start gap-2 text-left">
          <div className="shrink-0">
            <img alt="Alert" className="h-8 w-8" src={alertIcon} />
          </div>
          <div className="flex-1">
            <DialogTitle className="text-secondary mb-0.5 text-base font-semibold">
              {title}
            </DialogTitle>
            <DialogDescription className="text-secondary text-sm">{description}</DialogDescription>
          </div>
        </DialogHeader>
        <DialogFooter className="mt-2 flex-row justify-end gap-2">
          <Button
            className="text-secondary border-border-subtle hover:bg-back-bg2 bg-card m-0 border"
            onClick={() => onOpenChange(false)}
            size="default"
            variant="outline"
          >
            {cancelLabel}
          </Button>
          <Button
            className="bg-destructive text-destructive-foreground hover:bg-destructive m-0 hover:opacity-90"
            disabled={isPending}
            onClick={onConfirm}
          >
            {confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
